import React from 'react';
import { COLORS } from '../App';

const WORKFLOW_STEPS = [
  { key: 'pipeline', label: 'Deal Pipeline', icon: '\u{1F4CB}' },
  { key: 'intake', label: '1. Deal Intake', icon: '\u{1F4E7}' },
  { key: 'extraction', label: '2. Extract & Review', icon: '⚡' },
  { key: 'underwriting', label: '3. Underwriting Assumptions', icon: '\u{1F3DB}' },
  { key: 'populate', label: '4. Populate Model', icon: '\u{1F4CA}' },
  { key: 'comps', label: '5. Comp Search', icon: '\u{1F50D}' },
  { key: 'documents', label: '6. Lender-Generated Documents', icon: '\u{1F4C4}' },
  { key: 'borrower_diligence', label: '7. Borrower Diligence', icon: '\u{1F4C2}' },
  { key: 'third_party', label: '8. Third-Party Reports', icon: '\u{1F52C}' },
  { key: 'buyerqa', label: '9. Buyer Q&A', icon: '\u{1F4AC}' },
];

export default function Layout({ user, view, activeDeal, onNavigate, onLogout, onBackToPipeline, children }) {
  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>
      <div style={{ width: 240, background: COLORS.navy, color: COLORS.white, display: 'flex', flexDirection: 'column', position: 'fixed', top: 0, left: 0, bottom: 0, zIndex: 10 }}>
        <div onClick={onBackToPipeline} style={{ padding: '16px', borderBottom: `1px solid ${COLORS.navyLight}`, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 10 }}>
          <img src="/tranchedesk-icon.png" alt="" style={{ width: 28, height: 28, borderRadius: 4 }} />
          <span style={{ fontFamily: 'Georgia, serif', fontSize: 18, color: COLORS.gold }}>TrancheDesk</span>
        </div>

        {activeDeal && (
          <div style={{ padding: '12px 16px', borderBottom: `1px solid ${COLORS.navyLight}`, fontSize: 12 }}>
            <div style={{ color: COLORS.gold, fontWeight: 600, marginBottom: 4 }}>{activeDeal.property_name}</div>
            <div style={{ color: '#8899AA' }}>{activeDeal.dmp_deal_id || activeDeal.property_type || 'No type set'}</div>
          </div>
        )}

        <nav style={{ flex: 1, paddingTop: 8, overflowY: 'auto' }}>
          {WORKFLOW_STEPS.map(step => (
            <div key={step.key}
              onClick={() => onNavigate(step.key)}
              style={{
                padding: '10px 16px', cursor: 'pointer', fontSize: 12, display: 'flex', alignItems: 'center', gap: 10,
                background: view === step.key ? COLORS.navyLight : 'transparent',
                borderLeft: view === step.key ? `3px solid ${COLORS.gold}` : '3px solid transparent',
              }}
              onMouseEnter={e => { if (view !== step.key) e.currentTarget.style.background = COLORS.navyLight; }}
              onMouseLeave={e => { if (view !== step.key) e.currentTarget.style.background = 'transparent'; }}>
              <div style={{
                width: 26, height: 26, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: 13, flexShrink: 0,
                background: view === step.key ? COLORS.gold : '#162A45',
                color: view === step.key ? COLORS.navy : '#6B7A8D',
              }}>{step.icon}</div>
              <span>{step.label}</span>
            </div>
          ))}

          {/* Working Documents */}
          <div style={{ borderTop: `1px solid ${COLORS.navyLight}`, marginTop: 12, paddingTop: 8 }}>
            <div style={{ padding: '4px 16px', fontSize: 10, color: '#667788', textTransform: 'uppercase', letterSpacing: 1 }}>Working Documents</div>
            <div onClick={() => onNavigate('deal_notes')}
              style={{
                padding: '10px 16px', cursor: 'pointer', fontSize: 12, display: 'flex', alignItems: 'center', gap: 10,
                background: view === 'deal_notes' ? COLORS.navyLight : 'transparent',
                borderLeft: view === 'deal_notes' ? `3px solid ${COLORS.gold}` : '3px solid transparent',
              }}
              onMouseEnter={e => { if (view !== 'deal_notes') e.currentTarget.style.background = COLORS.navyLight; }}
              onMouseLeave={e => { if (view !== 'deal_notes') e.currentTarget.style.background = 'transparent'; }}>
              <div style={{ width: 26, height: 26, borderRadius: '50%', background: view === 'deal_notes' ? COLORS.gold : '#162A45', color: view === 'deal_notes' ? COLORS.navy : '#6B7A8D', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13 }}>{'📝'}</div>
              <span>Deal Notes</span>
            </div>
          </div>

          {/* Admin section */}
          <div style={{ borderTop: `1px solid ${COLORS.navyLight}`, marginTop: 4, paddingTop: 8 }}>
            <div style={{ padding: '4px 16px', fontSize: 10, color: '#667788', textTransform: 'uppercase', letterSpacing: 1 }}>Admin</div>
            <div onClick={() => onNavigate('templates')}
              style={{
                padding: '10px 16px', cursor: 'pointer', fontSize: 12, display: 'flex', alignItems: 'center', gap: 10,
                background: view === 'templates' ? COLORS.navyLight : 'transparent',
                borderLeft: view === 'templates' ? `3px solid ${COLORS.gold}` : '3px solid transparent',
              }}
              onMouseEnter={e => { if (view !== 'templates') e.currentTarget.style.background = COLORS.navyLight; }}
              onMouseLeave={e => { if (view !== 'templates') e.currentTarget.style.background = 'transparent'; }}>
              <div style={{ width: 26, height: 26, borderRadius: '50%', background: view === 'templates' ? COLORS.gold : '#162A45',
                color: view === 'templates' ? COLORS.navy : '#6B7A8D', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13 }}>{'⚙'}</div>
              <span>UW Templates</span>
            </div>
            <div onClick={() => onNavigate('llm-settings')}
              style={{
                padding: '10px 16px', cursor: 'pointer', fontSize: 12, display: 'flex', alignItems: 'center', gap: 10,
                background: view === 'llm-settings' ? COLORS.navyLight : 'transparent',
                borderLeft: view === 'llm-settings' ? `3px solid ${COLORS.gold}` : '3px solid transparent',
              }}
              onMouseEnter={e => { if (view !== 'llm-settings') e.currentTarget.style.background = COLORS.navyLight; }}
              onMouseLeave={e => { if (view !== 'llm-settings') e.currentTarget.style.background = 'transparent'; }}>
              <div style={{ width: 26, height: 26, borderRadius: '50%', background: view === 'llm-settings' ? COLORS.gold : '#162A45',
                color: view === 'llm-settings' ? COLORS.navy : '#6B7A8D', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13 }}>{'\u{1F9E0}'}</div>
              <span>LLM Settings</span>
            </div>
          </div>
        </nav>

        <div style={{ padding: 16, borderTop: `1px solid ${COLORS.navyLight}`, fontSize: 12 }}>
          <div style={{ color: '#8899AA', marginBottom: 8 }}>{user.full_name}</div>
          <div onClick={onLogout} style={{ color: COLORS.gold, cursor: 'pointer' }}>Sign Out</div>
        </div>
      </div>

      <div style={{ marginLeft: 240, flex: 1, background: COLORS.bg, minHeight: '100vh' }}>
        <header style={{ background: COLORS.white, borderBottom: `1px solid ${COLORS.border}`, padding: '14px 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h2 style={{ fontFamily: 'Georgia, serif', fontSize: 20, color: COLORS.navy }}>
            {activeDeal ? activeDeal.property_name : view === 'templates' ? 'UW Templates' : 'Deal Pipeline'}
          </h2>
          {activeDeal && (
            <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
              {activeDeal.template_name && (
                <span style={{ fontSize: 12, color: COLORS.textLight }}>
                  Template: <strong style={{ color: COLORS.navy }}>{activeDeal.template_name} v{activeDeal.template_version}</strong>
                </span>
              )}
              <span style={{ fontSize: 12, padding: '4px 10px', borderRadius: 12, background: COLORS.goldLight, color: COLORS.navy, fontWeight: 600 }}>{activeDeal.status}</span>
            </div>
          )}
        </header>
        <main style={{ padding: 24 }}>{children}</main>
      </div>
    </div>
  );
}
